import { render, staticRenderFns } from "./ProductGalleryZoomCarousel.vue?vue&type=template&id=f5996494&scoped=true&"
import script from "./ProductGalleryZoomCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryZoomCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleryZoomCarousel.vue?vue&type=style&index=0&id=f5996494&lang=scss&scoped=true&"
import style1 from "./ProductGalleryZoomCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5996494",
  null
  
)

export default component.exports